// extracted by mini-css-extract-plugin
module.exports = {"classAssignPackButton":"AddClassPack_classAssignPackButton__1h_-y","classAssignPackButtonInfo":"AddClassPack_classAssignPackButtonInfo__1cSVk"};